export default __webpack_public_path__ + "static/media/bike-repair-station.60d3125a.svg";